import { render } from "./AttrSchemeGraphErd.vue?vue&type=template&id=03ae2b16"
import script from "./AttrSchemeGraphErd.vue?vue&type=script&lang=js"
export * from "./AttrSchemeGraphErd.vue?vue&type=script&lang=js"

import "./AttrSchemeGraphErd.vue?vue&type=style&index=0&id=03ae2b16&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/widgets/components_core/AttrSchemeGraphErd.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "03ae2b16"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('03ae2b16', __exports__)) {
    api.reload('03ae2b16', __exports__)
  }
  
  module.hot.accept("./AttrSchemeGraphErd.vue?vue&type=template&id=03ae2b16", () => {
    api.rerender('03ae2b16', render)
  })

}


export default __exports__